import { useState, useEffect } from 'react';
import { LocalStorage, KEYS } from '@/utils/LocalStorage';

export const useKitType = (): string => {
  const [kitType, setKitType] = useState('');

  useEffect(() => {
    const localBootupState = LocalStorage.getItem(KEYS.BOOTUP);

    if (localBootupState) {
      try {
        const parsedBootupState = JSON.parse(localBootupState);
        setKitType(parsedBootupState.kitType ?? '');
      } catch (error) {
        console.error(
          'Failed to parse bootup state from local storage:',
          error,
        );
      }
    }
  }, []);

  return kitType;
};
